import Top20Rankings2025 from "../../../components/best/Top20Rankings2025";

export { Page }

function Page() {
  return <Top20Rankings2025 />;
}